import { render, staticRenderFns } from "./QuickPayNormalPage.vue?vue&type=template&id=57551a7c&scoped=true"
import script from "./QuickPayNormalPage.vue?vue&type=script&lang=js"
export * from "./QuickPayNormalPage.vue?vue&type=script&lang=js"
import style0 from "./QuickPayNormalPage.vue?vue&type=style&index=0&id=57551a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57551a7c",
  null
  
)

export default component.exports